export default __webpack_public_path__ + "static/media/D127FEA3-8964-44B8-AA0F-65205DA40C6D_1_105_c.f531e456.jpeg";